import React from "react";
import { Box, Grid2 as Grid, Tabs, Tab, } from "@mui/material";

import { ConditionalGrid } from "@shared/components";
import { ProductForm } from "../ProductForm";
import { ProductPlans } from "../ProductPlans";
import { useParams } from "react-router";

export function ProductTabs() {
  const { id } = useParams();
  const [selectedTab, setSelectedTab] = React.useState(0);

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12 }}>
          <Tabs value={selectedTab} onChange={(_, v) => setSelectedTab(v)}>
            <Tab label="Configurações gerais" />
            <Tab disabled={!id} label="Planos" />
          </Tabs>
        </Grid>

        <ConditionalGrid container spacing={2} isVisible={selectedTab === 0}>
          <Grid size={{ xs: 12 }}>
            <ProductForm />
          </Grid>
        </ConditionalGrid>

        <ConditionalGrid container spacing={2} isVisible={selectedTab === 1}>
          <Grid size={{ xs: 12 }}>
            <ProductPlans />
          </Grid>
        </ConditionalGrid>
      </Grid>
    </Box>
  );
}


